<soft-field-ok
  fieldOkName="zahlstam"
  placeholder="Zahlungsart"
  [title]="configuration()?.title ?? ''"
  [subtitle]="configuration()?.subtitle ?? ''"
  [parameters]="parameters()"
  [readonly]="readonly()"
  [value]="value()"
  (valueChange)="valueChange.emit($event)"
></soft-field-ok>
